import { IconNameType } from "../../shared/icons/icon-name-type.enum"
import { AddressTypes } from '../models/address-types.enum';

export class IconUtils {

    public static calcAddressIcon(addressType: string | undefined): IconNameType {
        switch(addressType) {
        case AddressTypes.APARTMENT: {
            return IconNameType.apartment
        }
        case AddressTypes.SINGLE_FAMILY: {
            return IconNameType.home
        }
        case AddressTypes.BUSINESS: {
            return IconNameType.business
        }
        case AddressTypes.HOSPITAL: {
            return IconNameType.hospital
        }
        case AddressTypes.HOTEL: {
            return IconNameType.hotel
        }
        default: {
            return IconNameType.otherAddressType
        }
        }
    }
}
